import React, { useCallback, useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  Character,
  CharacterFeature,
  CharacterKnowledge,
  Creature,
  CreatureLimitation,
  KnowledgeFeature,
} from "@dndModels";
import { ModelBase } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  character: Character;
  obj: CharacterFeature;
  onChange: () => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterKnowledgeFeatureInput({ 
  character,
  obj,
  onChange,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [creatures, setCreatures] = useState<Creature[]>([]);
  const [objects, setObjects] = useState<ModelBase[]>([]);

  const load = useCallback( async () => {
    setFetched(true);
    if (obj.floating_feature instanceof KnowledgeFeature) {
      const kf = obj.floating_feature;
      setLoading(true);
      const res = await api.getSetOfObjects({ data_types: ["creature"]});
      // debugger;
      let filtered = res.creature as Creature[];
      const limitations = kf.limitations;
      const limit = char_util.findLimitation(limitations, character, obj.source_true_id);
      if (limit instanceof CreatureLimitation) {
        if (limit.creature_ids.length > 0) {
          filtered = filtered.filter(o => limit.creature_ids.includes(o._id));
        }
        if (!limit.allow_flight) {
          filtered = filtered.filter(o => !o.flying);
        }
        if (!limit.allow_swimming) {
          filtered = filtered.filter(o => !o.swimming);
        }
        if (limit.creature_types.length > 0) {
          filtered = filtered.filter(o => limit.creature_types.includes(o.creature_type));
        }
        if (limit.subtypes.length > 0) {
          filtered = filtered.filter(o => common_util.anyOverlaps(limit.subtypes, o.subtypes));
        }
        if (limit.size_nums.length > 0) {
          filtered = filtered.filter(o => limit.size_nums.includes(o.size_num));
        }
        if (limit.min_challenge_rating > -1) {
          filtered = filtered.filter(o => limit.min_challenge_rating <= o.challenge_rating);
        }
        if (limit.max_challenge_rating > -1) {
          filtered = filtered.filter(o => limit.max_challenge_rating >= o.challenge_rating);
        }
      }
      setCreatures(filtered);
      const res2 = await data_util.getObjects(kf.type);
      setObjects(res2);
      setLoading(false);
    }
  }, [obj]);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  }, [fetched, load]);

  if (!fetched || loading) {
    return <LoadingBox />;
  } else if (obj.floating_feature instanceof KnowledgeFeature) {
    const kf = obj.floating_feature;

    const count = char_util.value(kf.count, { obj: character, source_id: obj.source_true_id, root_id: obj.root_id });
    if (objects.length === count) {
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            Known {kf.type}s
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            { objects.map(o => o.true_name).join(", ") }
          </Grid>
        </Grid>
      );
    }

    const renderCreatureSelect = () => {
      const knowledges = obj.feature_options as CharacterKnowledge[];
      console.log(knowledges);
      const border = knowledges.filter(o => o.obj_id === "").length > 0 ? "1px solid #1C9AEF" : "1px solid #777777";
      return (
        <Grid
          style={{ border }}
          size={{
            xs: 12
          }}>
          <CharacterListOptionsInput
            data_type="creature"
            char={character}
            choose_max={count} 
            use_objects={creatures}
            selected={knowledges.map(o => o.obj_id).filter(o => o !== "")} 
            force_selectable
            quick_fields={["min_cr","max_cr","creature_type"]}
            onLoadedFilter={(objects: ModelBase[]) => {
              // debugger;
              const new_filter: any = { search_string: [""] };
              if (objects.length > 0 && objects[0] instanceof Creature) {
                const creatures = objects as Creature[];
                const min_cr = Math.min(...creatures.map(o => o.min_challenge_rating));
                const max_cr = Math.max(...creatures.map(o => o.max_challenge_rating));
                new_filter.min_cr = [`${min_cr}`]; // { "$gte": min_cr };
                new_filter.max_cr = [`${max_cr}`]; // { "$lte": max_cr };
              }
              return new_filter;
            }}
            onChange={(changed: string[]) => {
              debugger;
              for (let i = 0; i < changed.length; ++i) {
                const knowledge = obj.feature_options[i] as CharacterKnowledge;
                knowledge.obj_id = changed[i];
              }
              for (let i = changed.length; i < obj.feature_options.length; ++i) {
                const knowledge = obj.feature_options[i] as CharacterKnowledge;
                knowledge.obj_id = "";
              }
              onChange();
            }} 
          />
        </Grid>
      );
    }

    // debugger;
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className='centered header'
          size={{
            xs: 12
          }}>
          Known {kf.type}s
        </Grid>
        { (kf.type === "Creature" || kf.type === "creature") && renderCreatureSelect() }
      </Grid>
    );
  }
  return <></>;
}
